document.addEventListener('DOMContentLoaded', function() {
  const panelSizeSelect = document.getElementById('preset-sizes');
  const widthInput = document.getElementById('width');
  const heightInput = document.getElementById('height');
  const resultDiv = document.getElementById('pc-result');

  // Varsayılan olarak ürünün meta bilgisinden ölçüler
  let panelWidth = window.panelWidth;
  let panelHeight = window.panelHeight;

  // Eğer dropdown varsa ve seçim yapılırsa, panel ölçüsünü güncelle, inputları sıfırla
  if(panelSizeSelect) {
    panelSizeSelect.addEventListener('change', function() {
      const val = this.value;
      if(val && val.includes('x')) {
        const [w, h] = val.split('x').map(Number);
        // Panel ölçüsünü seçilene güncelle
        panelWidth = w;
        panelHeight = h;
        // INPUTLARI SIFIRLA
        widthInput.value = '';
        heightInput.value = '';
        // Sonuçları sıfırla
        updateResult();
      } else {
        // Dropdown sıfırlandığında meta ölçülere geri dön
        panelWidth = window.panelWidth;
        panelHeight = window.panelHeight;
        widthInput.value = '';
        heightInput.value = '';
        updateResult();
      }
    });
  }

  function calcPanels(w, h, pw, ph) {
    if (!w || !h || !pw || !ph) return 0;
    const areaWall = (w / 100) * (h / 100);
    const areaPanel = (pw / 100) * (ph / 100);
    return Math.ceil(areaWall / areaPanel);
  }

  function updateResult() {
    const width = Number(widthInput.value);
    const height = Number(heightInput.value);

    let totalArea = 0;
    let count = 0;

    // Hesaplamada: panelWidth/panelHeight, ya meta’dan ya da dropdown seçiminden
    if (!isNaN(width) && !isNaN(height) && width >= 1 && height >= 1) {
      totalArea = (width * height) / 10000;
      count = calcPanels(width, height, panelWidth, panelHeight);
    }

    resultDiv.innerHTML = `
      <div style="font-size:17px; color:#ff6600; margin-bottom:5px; ">
        Superficie total: <b>${totalArea.toFixed(2)} m²</b>
      </div>
      <div style="font-size:15px; font-weight:600; color:#ff6600; margin-bottom:5px;">
        Se necesitan ${count > 0 ? count : 0} paneles
      </div>
    `;
  }

  // Inputlara yazınca hesapla
  widthInput.addEventListener('input', updateResult);
  heightInput.addEventListener('input', updateResult);

  // Sayfa yüklenince de sıfırdan göster
  updateResult();
});
